import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            精彩推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            热门影视专题精选，发现你的下一部心头好
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden transition-all duration-200 hover:border-primary-300/50 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={`51影院 - ${item.title}`}
                  title={`51影院${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="px-2 py-0.5 bg-black/60 text-white text-xs rounded-md">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}